/**
 * Resolve OpenAPI/Swagger documents from resource records for Swagger UI.
 * Handles stringified JSON in `data`, alternate field names, wrapped payloads,
 * and inline specs stored on the resource.
 */

export function normalizeResourceData(data) {
  if (data == null) return {}
  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data)
      return typeof parsed === 'object' && parsed !== null ? parsed : {}
    } catch {
      return {}
    }
  }
  return typeof data === 'object' ? data : {}
}

export function isValidOpenApiRoot(obj) {
  if (!obj || typeof obj !== 'object') return false
  if (obj.swagger === '2.0') return true
  if (typeof obj.openapi === 'string' && /^3(\.\d+){1,2}/.test(obj.openapi)) return true
  return false
}

/** If the payload is a spec or wraps one (e.g. API gateway envelope), return the inner document. */
export function unwrapSpecDocument(obj) {
  if (!obj || typeof obj !== 'object') return null
  if (isValidOpenApiRoot(obj)) return obj
  const keys = ['data', 'body', 'document', 'spec', 'definition', 'openapi', 'openApi']
  for (const k of keys) {
    const v = obj[k]
    if (v && typeof v === 'object' && isValidOpenApiRoot(v)) return v
    if (typeof v === 'string') {
      try {
        const parsed = JSON.parse(v)
        if (parsed && typeof parsed === 'object' && isValidOpenApiRoot(parsed)) return parsed
      } catch {
        /* ignore */
      }
    }
  }
  return null
}

export function pickSpecUrlFromResource(resource) {
  const data = normalizeResourceData(resource?.data)
  return (
    data.openApiUrl ||
    data.openapiUrl ||
    data.openAPIUrl ||
    data.swaggerUrl ||
    data.specUrl ||
    resource?.endpoint ||
    null
  )
}

/**
 * @returns {{ kind: 'inline', spec: object } | { kind: 'url', url: string } | null}
 */
export function resolveOpenApiSpecFromResource(resource) {
  if (!resource) return null
  const data = normalizeResourceData(resource.data)

  const inlineKeys = ['openApi', 'openapi', 'definition', 'spec']
  for (const k of inlineKeys) {
    const v = data[k]
    if (v && typeof v === 'object') {
      const doc = unwrapSpecDocument(v)
      if (doc) return { kind: 'inline', spec: doc }
    }
    if (typeof v === 'string') {
      try {
        const parsed = JSON.parse(v)
        const doc = unwrapSpecDocument(parsed)
        if (doc) return { kind: 'inline', spec: doc }
      } catch {
        /* ignore */
      }
    }
  }

  const whole = unwrapSpecDocument(data)
  if (whole) return { kind: 'inline', spec: whole }

  const url = pickSpecUrlFromResource(resource)
  if (url) return { kind: 'url', url }
  return null
}

export function isLikelyYamlUrl(url) {
  if (!url || typeof url !== 'string') return false
  const u = url.toLowerCase()
  return u.includes('.yaml') || u.includes('.yml') || u.includes('format=yaml')
}
